<template>
    <Modal v-model="show"
        :width="70"
        :footer-hide="true"
        title="客户配送运费设置"
        class-name="vertical-center-modal"
        @on-visible-change="onShowChange">
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <Form label-position="top"
                    class="small-form">

                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="省份">
                            <Select v-model="costForm.provinceUuid"
                                filterable
                                transfer
                                @on-change="onProvinceChange">
                                <Option v-for="item in provinceOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid">{{ item.regionName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="城市">
                            <Select v-model="costForm.cityUuid"
                                filterable
                                transfer
                                @on-change="onCityChange">
                                <Option v-for="item in cityOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid">{{ item.regionName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="区域">
                            <Select v-model="costForm.distUuid"
                                transfer
                                filterable>
                                <Option v-for="item in distOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid">{{ item.regionName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="物流公司">
                            <Select v-model="costForm.logisticsCompanyUuid"
                                transfer
                                filterable>
                                <Option v-for="item in logisticsCompanyList"
                                    :key="item.logisticsCompanyUuid"
                                    :value="item.logisticsCompanyUuid">{{ item.logisticsCompanyName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="运费">
                            <decimal-input v-model="costForm.logisticsCompanyPerVolumePrice"
                                :precision="4"
                                :min="0" />
                        </FormItem>
                        </Col>

                        <Col span="2">
                        <FormItem label=" ">
                            <Button type="primary"
                                @click="onAddCost">添加</Button>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>

                <Table :columns="costTable.columns"
                    size="small"
                    :data="costTable.rows"
                    highlight-row
                    stripe
                    border />
                </Col>
            </Row>

            <Row :gutter="16"
                class="row-margin-top-15"
                style="margin-top:20px;text-align:right;">
                <Col span="24">
                <Button type="primary"
                    @click="onSubmit">保存</Button>
                </Col>
            </Row>
        </Card>
    </Modal>

</template>

<script>
import DecimalInput from '@/components/number-input/decimal-input';
import { numberToFixedString } from '@/components/number-input/display-format';

import {
    getDistributionStationToCustomerCostSetting,
    saveDistributionStationToCustomerCostSetting
} from '@/api/modules/system-management/distributionStation-management';

export default {
    name: 'DistributionStationToCustomerCost',
    components: {
        DecimalInput
    },
    data() {
        return {
            show: false,
            allRegions: [],
            logisticsCompanyList: [],
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            costList: [],
            costTable: {
                columns: [
                    { title: '省份', key: 'provinceName', align: 'center' },
                    { title: '城市', key: 'cityName', align: 'center' },
                    { title: '区域', key: 'distName', align: 'center' },
                    { title: '物流公司', key: 'logisticsCompanyName', align: 'center' },
                    { title: '运费', key: 'logisticsCompanyPerVolumePrice', align: 'center', render: (h, params) => h('span', {}, numberToFixedString(params.row.logisticsCompanyPerVolumePrice, 4)) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onRemove(params.index);
                                        }
                                    }
                                }, '删除')]);
                        }
                    }
                ],
                rows: []
            },
            costForm: {
                provinceUuid: '',
                cityUuid: '',
                distUuid: '',
                logisticsCompanyUuid: '',
                logisticsCompanyPerVolumePrice: 0
            }
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        init() {
            this.$showGlobalSpin();
            getDistributionStationToCustomerCostSetting().then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.logisticsCompanyList = res.data.logisticsCompanyList;
                    this.allRegions = res.data.allRegions;
                    this.costList = res.data.costList;

                    this.provinceOptions = this.allRegions.filter(r => r.regionType === 1);
                    this.cityOptions = [];
                    this.distOptions = [];

                    this.costTable.rows = this.costList;
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
        },
        onProvinceChange(provinceUuid) {
            this.costForm.distUuid = '';
            this.distOptions = [];

            this.costForm.cityUuid = '';
            this.cityOptions = this.allRegions.filter(r => r.regionType === 2 && r.regionParentUuid === provinceUuid);
        },
        onCityChange(cityUuid) {
            this.costForm.distUuid = '';
            this.distOptions = this.allRegions.filter(r => r.regionType === 3 && r.regionParentUuid === cityUuid);
        },
        onAddCost() {
            if (this.costForm.distUuid && this.costForm.logisticsCompanyUuid) {
                const exists = this.costTable.rows.find(r => r.distUuid === this.costForm.distUuid);
                if (!exists) {
                    const province = this.provinceOptions.find(o => o.regionUuid === this.costForm.provinceUuid);
                    const city = this.cityOptions.find(o => o.regionUuid === this.costForm.cityUuid);
                    const dist = this.distOptions.find(o => o.regionUuid === this.costForm.distUuid);
                    const logisticsCompany = this.logisticsCompanyList.find(o => o.logisticsCompanyUuid === this.costForm.logisticsCompanyUuid);
                    this.costTable.rows.push({
                        provinceUuid: this.costForm.provinceUuid,
                        provinceName: province.regionName,
                        cityUuid: this.costForm.cityUuid,
                        cityName: city.regionName,
                        distUuid: this.costForm.distUuid,
                        distName: dist.regionName,
                        logisticsCompanyName: logisticsCompany.logisticsCompanyName,
                        logisticsCompanyUuid: this.costForm.logisticsCompanyUuid,
                        logisticsCompanyPerVolumePrice: this.costForm.logisticsCompanyPerVolumePrice
                    });
                }
            }
        },
        onRemove(index) {
            this.costTable.rows.splice(index, 1);
        },
        onSubmit() {
            const settings = this.costTable.rows.map(r => {
                return {
                    distUuid: r.distUuid,
                    logisticsCompanyUuid: r.logisticsCompanyUuid,
                    logisticsCompanyPerVolumePrice: r.logisticsCompanyPerVolumePrice
                };
            });

            this.$showGlobalSpin();
            saveDistributionStationToCustomerCostSetting({ settings }).then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.init();
                        }
                    });
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
        }
    }
};
</script>

<style scoped>
</style>
